import { Order } from "../models";

/** Collect the unique location ids referenced by a set of orders' route stops. */
export const getLocationIdsFromOrders = (orders: Order[]): string[] => {
  const locationIds = new Set<string>();

  orders.forEach((order) => {
    if (order.route && order.route.length > 0) {
      order.route.forEach((routeItem) => {
        if (routeItem.location && routeItem.location.id) {
          locationIds.add(routeItem.location.id);
        }
      });
    }
  });

  return Array.from(locationIds);
};
